export enum ApprovalStatus {
    Approved = 'Approved',
    Flagged = 'Flagged',
    Rejected = 'Rejected',
}
